import { breakpoints, sizes } from '@bnnvara/breakpoints';
import { BaseButton } from '@bnnvara/buttons';
import styled, { keyframes } from 'styled-components';

export const Content = styled.div`
  width: 75%;
  max-width: 343px;
  height: auto;
  margin: auto;
  background-color: ${({ theme }) => theme.base.white};
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${breakpoints.md} {
    max-width: 500px;
    width: 100%;
  }
  ${breakpoints.md} {
    padding: 32px;
  }
`;

export const CloseButton = styled(BaseButton)`
  margin: 20px 0;
`;

export const hideMessage = keyframes`
   0%   {opacity: 1;}
   80%   {opacity: 1;}
   100%  {opacity: 0;}
 `;

export const MessageBox = styled.div`
  opacity: ${(props) => (props.followedModalIsOpen ? 1 : 0)};
  pointer-events: none;
  animation: ${(props) => (props.followedModalIsOpen ? hideMessage : '')} 5s
    forwards;
  position: absolute;
  font-size: 14px;
  padding: 11px;
  line-height: 18px;
  background: #0772e6;
  color: #fff;
  margin-top: -42px;

  ${breakpoints.md} {
    margin-top: -24px;
  }
`;

export const FollowButtonContainer = styled.div`
  max-width: 100px;
  position: relative;

  ${breakpoints.md} {
    display: inline-flex;
  }
`;

export const NotificationPosition = styled.div`
  position: relative;

  @media (max-width: ${sizes.lg}px) {
    width: 100%;
    max-width: 400px;
  }
`;

export const NotificationContainer = styled.div`
  position: absolute;
  margin-top: 30px;
  z-index: 5;

  ${breakpoints.lg} {
    width: max-content;
    max-width: 531px;
    margin-top: 0px;
    top: calc(50% - -6px);
    left: calc(100% + 30px);
    transform: translateY(-50%);
    margin-left: 14px;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
`;

export const InnerModal = styled.div`
  padding: 55px 30px;
  position: absolute;
  background: ${({ theme }) => theme.base.white};

  & > div[data-testid='loading-component'] {
    margin: auto;
    padding: 24px;
  }

  @media screen and (max-width: 767px) {
    position: fixed;
    left: 20px;
    right: 20px;
  }

  > h2 {
    @media screen and (max-width: 767px) {
      white-space: initial;
    }
  }
`;

export const NotificationContent = styled.div`
  max-width: 516px;

  h2 {
    font-size: 1.75rem;
    font-weight: 700;
    margin-bottom: 1.5rem;
  }

  h3 {
    font-size: 1.25rem;
    margin-bottom: 1rem;
  }

  label {
    align-items: center;

    & > span {
      white-space: normal;
    }
  }
`;
